import type { DropPosition } from '../dndTree'

interface DropIndicatorProps {
  position: DropPosition
  depth: number
}

export default function DropIndicator({ position, depth }: DropIndicatorProps) {
  if (position === 'inside') return null

  return (
    <div
      className="absolute left-0 right-0 z-10 pointer-events-none"
      style={{
        top: position === 'before' ? -1 : undefined,
        bottom: position === 'after' ? -1 : undefined,
        paddingLeft: `${depth * 24 + 28}px`,
      }}
    >
      <div className="h-[3px] bg-gold rounded-full shadow-[0_0_8px_rgba(200,149,48,0.5)]" />
    </div>
  )
}
